<template>
  <div class="wrapper">
    <div class="ourGoalIsSimple">
      <div class="text">
        <h2 v-html="$t('page.whatIsLiffery.new2023.OOurMission.title1')"></h2>
        <p class="mt-6 font-body-l">
          {{ $t('page.whatIsLiffery.new2023.OOurMission.text1') }}
        </p>
        <p class="mt-6 font-body-l">
          {{ $t('page.whatIsLiffery.new2023.OOurMission.text2') }}
        </p>
        <p class="mt-6 cta-button-control">
          <router-link
            v-if="getIsAuthenticated"
            :to="{name: routeNames.ROUTE_DASHBOARD}"
          >
            <b-button>
              {{ $t('page.whatIsLiffery.new2023.loggedIn') }}
            </b-button>
          </router-link>
          <b-button
            v-else
            type="is-primary"
            @click="loginPrompt"
          >
            {{ $t('page.whatIsLiffery.new2023.OOurMission.cta') }}
          </b-button>
        </p>
      </div>
      <div class="product-image">
        <img src="@/assets/landing-pages/forPeople/2023/liffery-info-card.png"
             srcset="@/assets/landing-pages/forPeople/2023/liffery-info-card.png 1x,
                  @/assets/landing-pages/forPeople/2023/liffery-info-card2x.png 2x"
             alt="Liffery item card"
             class="item-card-image">

        <img src="@/assets/landing-pages/forPeople/2023/liffery-info-card-mobile.png"
             srcset="@/assets/landing-pages/forPeople/2023/liffery-info-card-mobile.png 1x,
                  @/assets/landing-pages/forPeople/2023/liffery-info-card-mobile.png 2x"
             alt="Liffery item card mobile"
             class="item-card-image-mobile">
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.wrapper {
  max-width: $desktop;
  margin-left: auto;
  margin-right: auto;

  @media screen and (max-width: $desktop + 1) {
    max-width: 94%;
  }
  @media screen and (max-width: $tablet + 1) {
    max-width: 90%;
  }


  h4 {
    font-weight: $fontWeightNormal !important;
  }

  .ourGoalIsSimple {
    display: flex;
    justify-content: center;
    gap: 0;
    background-color: $white;
    padding: 2rem;
    border: 1.5px solid rgba(13, 13, 13, 0.13);
    border-radius: 24px;

    h4 {
      max-width: 450px;
    }

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      &.text {
        width: calc(100% - 590px);
        margin-top: 4rem;
      }

      &.product-image {
        padding-top: 2rem;
        padding-bottom: 2rem;

        $itemcardWidth: 515px;

        img {
          width: $itemcardWidth;

          &.item-card-image {
            display: block;
          }

          &.item-card-image-mobile {
            display: none;
          }
        }

        @media screen and (max-width: 537px) {
          img {
            width: 350px;
          }
          .item-card-image {
            display: none;
          }
          .item-card-image-mobile {
            display: block;
          }
        }
      }
    }

    @media screen and (max-width: $desktop + 1) {
      gap: 1rem;
    }

    @media screen and (max-width: 900px) {
      flex-direction: column;
      align-items: center;
      border-radius: 18px;

      div {
        &.text {
          width: 75%;

          p.cta-button-control button {
            width: 100%;
          }
        }
      }
    }
  }

  .ourMissionIsBig {
    text-align: center;
    background-color: $primary;
    color: $white;
    padding: 4rem 2rem;
    border-radius: 24px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;

    h4 {
      margin: auto;
      max-width: 550px;
    }

    @media screen and (max-width: $tablet) {
      border-radius: 0;
    }
  }
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AuthenticationStore } from '@/store';
import { RouteNames } from '@/router/RouteNames';
import { EnumRegisteredFromAction } from '@/store/modules/interfaces/AuthenticationModule';

@Component
export default class OOurMission extends Vue {
  routeNames = RouteNames;

  get getIsAuthenticated () {
    return AuthenticationStore.getAuthenticated;
  }

  loginPrompt () {
    AuthenticationStore.TOGGLE_PROMPT_SIGNUP({
      state: true,
      metaData: {
        registeredFromAction: EnumRegisteredFromAction.ctaOurMission
      }
    });
  }
}
</script>
